module.exports = __webpack_public_path__ + "static/phy-exp-56dc16fa4745e78d3581ebaec9dc2716.svg";